import { getDiscountPrice } from "../../helpers/product";

/*
 * Image URLs arrive either as full Cloudinary links or as legacy relative
 * backend paths. Same rule the product gallery uses.
 */
export const resolveImage = (img) => {
  if (!img) return "";
  const value = String(img);
  if (value.startsWith("http")) return value;
  return `${process.env.REACT_APP_BACKEND_URL}/${value.replace(/\\/g, "/")}`;
};

/*
 * Line pricing for a cart or wishlist item.
 *
 * Mirrors the rules the cart page already used: a selected variation
 * takes its own basePrice (with the reseller deduction applied to the
 * variation's own resellerPrice, and no percentage discount), otherwise
 * the product's basePrice with the reseller deduction and then the
 * percentage discount.
 *
 * Returns values already converted to the active currency.
 */
export const getLinePricing = (item, currency, isReseller) => {
  const rate = currency.currencyRate || 1;

  if (item.selectedVariation) {
    const base = item.selectedVariation.price.basePrice;
    const net =
      isReseller && item.selectedVariation.resellerPrice
        ? base - item.selectedVariation.resellerPrice
        : base;
    const price = +(net * rate).toFixed(2);
    return { unitPrice: price, unitWas: null, discounted: false };
  }

  const base = item?.price?.basePrice ?? 0;
  const net = isReseller && item.resellerPrice ? base - item.resellerPrice : base;
  const discounted = getDiscountPrice(net, item.discount);

  const listPrice = +(net * rate).toFixed(2);
  if (discounted === null) {
    return { unitPrice: listPrice, unitWas: null, discounted: false };
  }
  return {
    unitPrice: +(discounted * rate).toFixed(2),
    unitWas: listPrice,
    discounted: true,
  };
};

/* Per-line delivery cost the cart slice keeps in sync with quantity. */
export const getLineShipping = (item, currency) => {
  const rate = currency.currencyRate || 1;
  const cost = Number(item.totalDeliveryCost ?? item.deliveryCost ?? 0) || 0;
  return +(cost * rate).toFixed(2);
};

export const formatMoney = (currency, value) =>
  `${currency.currencySymbol}${Number(value || 0).toFixed(2)}`;
